/* eslint-disable react/prop-types */
import React from "react";
import { File, Download } from "lucide-react";
import { Button } from "../ui/button";

export const NoPreview = (props) => {
  const { url, name, encrypted } = props;
  const downloadFile = () => {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name); // any other extension
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  return (
    <div className="flex flex-col items-center justify-center w-full h-full pt-[200px] overflow-auto rounded border shadow-lg border-gray-200">
      <File className="h-7 w-8" />
      <h3 className="mt-8 mb-3.5 text-sm text-[#32325d]">
        No Preview Available
      </h3>
      {encrypted ? (
        <div className="text-center text-base font-bold">
          This PDF is encrypted and can be previewed only with a password.
        </div>
      ) : (
        <Button
          variant="default"
          className="whitespace-nowrap py-2.5 px-4 rounded shadow-sm text-sm border border-[#ececec] w-[146px] h-9 flex items-center gap-2"
          onClick={downloadFile}
        >
          <Download className="h-4 w-4 text-white" />
          Download File
        </Button>
      )}
    </div>
  );
};
